<template>
  <div class="calContainer">
    <div class="Flex_Table">
      <div class="Flex_Row" style="border-bottom: solid">
        <div class="Flex_Cell_Inline">
          <span class="PrvNext">
            <a
              class="glyphicons left_arrow"
              v-on:click="onNextPrevMonthClick('1')"
              title="Prev Month"
            ></a>
          </span>
        </div>
        <div class="Flex_Cell calHead" valign="middle" align="center">
          <DateControl v-model="calMonth" :showDate="false"></DateControl>
        </div>
        <div class="Flex_Cell_Inline">
          <span class="PrvNext">
            <a
              class="glyphicons right_arrow"
              v-on:click="onNextPrevMonthClick('2')"
              title="Next Month"
            ></a>
          </span>
        </div>
      </div>
      <div class="Flex_Row">
        <!-- <div class="Flex_Cell_Inline" valign="middle">
                    <span class="WeekSelect">
                        <a class="glyphicons calendar" v-on:click="onMonthSelecter"
                        title="Select Month" ></a>
                    </span>
                </div> -->
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 14%"
        >
          SUN
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 14%"
        >
          MON
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 14%"
        >
          TUE
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 14%"
        >
          WED
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 14%"
        >
          THU
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 14%"
        >
          FRI
        </div>
        <div
          class="Flex_Cell"
          valign="middle"
          align="center"
          style="width: 16%"
        >
          SAT
        </div>
      </div>
      <div class="Flex_Row" v-for="d in calendar" :key="d.id">
        <!-- <div class="Flex_Cell_Inline" valign="middle">
                    <span class="WeekSelect">
                        <a class="glyphicons fast_forward" v-on:click="onWeekSelecter"
                            title="Select Full Week"></a>
                    </span>
                </div> -->
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 14%"
          v-html="typeOFDay(d.sun)"
          v-on:click="onSelectDate"
        ></div>
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 14%"
          v-html="typeOFDay(d.mon)"
          v-on:click="onSelectDate"
        ></div>
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 14%"
          v-html="typeOFDay(d.tue)"
          v-on:click="onSelectDate"
        ></div>
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 14%"
          v-html="typeOFDay(d.wed)"
          v-on:click="onSelectDate"
        ></div>
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 14%"
          v-html="typeOFDay(d.thu)"
          v-on:click="onSelectDate"
        ></div>
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 14%"
          v-html="typeOFDay(d.fri)"
          v-on:click="onSelectDate"
        ></div>
        <div
          class="Flex_Cell cellDivCommon"
          style="width: 16%"
          v-html="typeOFDay(d.sat)"
          v-on:click="onSelectDate"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import config from "@/router/globalConfig";
import DateControl from "./DateControl";
export default {
  props: {
    bookingTypeID: { default: -1, required: true },
    Type: { default: -1, required: true },
    eventBus: { type: Object },
  },
  components: {
    DateControl: DateControl,
  },
  data() {
    return {
      calMonth: new Date(),
      calendar: [],
      dayStatusList: [],
      slotDayDetail: [],
    };
  },
  methods: {
    getCalendar() {
      var type = 1;
      if (this.Type == 1) {
        type = 2;
      }
      const _data = {
        calDate: this.calMonth.convertToString("dd MMM yyyy"),
        bookingTypeID: this.bookingTypeID,
        type: type,
      };
      axios
        .get(config.WEB_API_PATH + "TicketBooking/GetCalendar", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.calendar = response.data.result;
            this.dayStatusList = response.data.result1;
            this.slotDayDetail = response.data.result2;
            //console.log(this.bookingTypeID);
          },
          (error) => {}
        );
    },
    onNextPrevMonthClick(pn) {
      if (pn == 1) {
        this.calMonth = new Date(this.calMonth).addMonths(-1);
      } else {
        this.calMonth = new Date(this.calMonth).addMonths(1);
      }
      //console.log(this.calMonth);
      //  vue.nextTick(()=>{
      //      this.getCalendar();
      //  });
    },
    typeOFDay(dayval) {
      let self = this;
      let dayDate = "01 Jan 1900";
      let _html = "";
      let dClass = "cellInsideDiv cellDivblank";
      let dtitle = "";
      let dText = "";
      let dCheckbox = "";
      let attendID = "";
      if (dayval != "") {
        let d = dayval.length == 1 ? "0" + dayval : dayval;
        dayDate = d + " " + self.calMonth.convertToString("MMM yyyy");
      }
      if (this.dayStatusList.length > 0) {
        this.dayStatusList.forEach(function (item, index) {
          if (item.dayValue == dayDate) {
            attendID =
              '<span style="display:none;" id="attendID" class="attendID">' +
              item.empAttendID +
              "</span>";
            if (item.isAvailable == "1") {
              dClass = "cellInsideDiv cellDiv";
              dtitle = "Available";
              dText = item.noOfSeatsLeft;
            }
            if (item.isOffDay == "1") {
              dClass = "cellInsideDiv cellDivFullOff";
              dtitle = "Off Day";
              dText = "";
            }
            if (item.isOffDay == "0" && item.isAvailable == "0") {
              dClass = "cellInsideDiv cellDivFullAbsent";
              dtitle = "No seat left";
              dText = "full";
            }
            //dText = item.commonNameDisplay;
          }
        });
        if (this.dayStatusList.length == 0 && dayval != "") {
          attendID =
            '<span style="display:none;" id="attendID" class="attendID">-1</span>';
          dClass = "cellInsideDiv cellDiv";
        }
      } else {
        attendID =
          '<span style="display:none;" id="attendID" class="attendID">-1</span>';
        dClass = "cellInsideDiv cellDiv";
      }

      if (dCheckbox != "") {
        _html +=
          '<div class="' +
          dClass +
          '" title="' +
          dtitle +
          '"  style="border:solid 2px black !important;">';
      } else {
        _html += '<div class="' + dClass + '" title="' + dtitle + '" >';
      }
      // _html +=
      //   '<span style="display:none;" id="calDate" class="calDate">' +
      //   dayDate +
      //   "</span>";
      _html += attendID;
      _html += '<label class ="chkContainer">';
      _html += dCheckbox;
      _html +=
        '<span class="checkmark">' +
        dayval +
        '<span style="display:none;" id="calDate" class="calDate">' +
        dayDate +
        "</span>" +
        "</span>";
      _html += "</label>";
      _html += '<span id="offdayData" class="offdayData">' + dText + "</span>";
      _html += "</div>";
      return _html;
    },
    onSelectDate(e) {
      //console.log($(e.target).parent().parent());
      if (
        $(e.target)[0].nodeName == "DIV" &&
        $(e.target)[0].className == "cellInsideDiv cellDiv"
      ) {
        // console.log("1");
        this.selectedDate = $(e.target).find(".calDate").text();
        this.$emit("change", this.selectedDate);
      } else if (
        $(e.target)[0].nodeName == "SPAN" &&
        $(e.target)[0].className == "offdayData" &&
        $(e.target).parent().attr("class") == "cellInsideDiv cellDiv"
      ) {
        // console.log("2");
        this.selectedDate = $(e.target).parent().find(".calDate").text();
        this.$emit("change", this.selectedDate);
      } else if (
        ($(e.target)[0].nodeName == "SPAN" &&
          $(e.target)[0].className == "checkmark" &&
          $(e.target).parent().parent().attr("class") ==
            "cellInsideDiv cellDiv") ||
        ($(e.target)[0].nodeName == "LABEL" &&
          $(e.target)[0].className == "chkContainer" &&
          $(e.target).parent().parent().attr("class") ==
            "cellInsideDiv cellDiv")
      ) {
        // console.log("3");
        let span = "";
        if ($(e.target)[0].nodeName == "SPAN") {
          span = $(e.target);
          this.selectedDate = $(span).find(".calDate").text();
        }
        this.$emit("change", this.selectedDate);

        // let chk = $(div).find(".cellCheckbox");

        // if (chk.length != 0) {
        //   if ($(chk).is(":checked")) {
        //     $(chk).prop("checked", false);
        //   } else {
        //     $(chk).prop("checked", true);
        //   }
        //   if ($("input:checkbox[class=cellCheckbox]:checked").length == 1) {
        //     this.getEmpAttendance(1, this.selectedDate);
        //   } else {
        //     this.attendStatus = 0;
        //     this.lateDayValue = 0;
        //     this.OTDayvalue = 0;
        //     this.isKeepInSameProcessMonth = false;
        //   }
        // }
      }
    },
  },
  mounted() {
    ekkJS.setDateControls();
    if (this.eventBus) {
      let _resetCalc = this.getCalendar;
      this.eventBus.$on("resetCalendar", function () {
        _resetCalc();
      });
    }
    this.getCalendar();
  },
  watch: {
    calMonth(newValue, oldValue) {
      this.getCalendar();
    },
  },
};
</script>
<style>
.calContainer {
  /* width: 45%; */
  background-color: #0000002b;
  border: 1px solid darkgray;
  border-radius: 8px;
  box-shadow: inset 0 0 20px 1px white;
  padding: 3px;
}
.cellDivCommon {
  /* width: 15%; */
  height: 45px;
  border-radius: 8px;
  margin-bottom: 3px;
  padding: 0px 2px !important;
}
.cellInsideDiv {
  height: 45px;
  border-radius: 8px;
}
.cellDiv {
  border: solid thin darkgray;
  background-color: GreenYellow; /* #ffffff63; /*#4ccaef33;*/
  box-shadow: 0px 0px 3px #8196b6;
  cursor: pointer;
}
.cellDivblank {
  background-color: rgba(202, 202, 202, 0.24);
}
.cellDiv:hover {
  border: solid thin #4ccaef;
  background-color: rgba(249, 249, 249, 0.527) !important;
  /* cursor: pointer; */
  box-shadow: 0px 0px 3px #8196b6;
}
.cellDivFullAbsent {
  border: solid thin #4ccaef;
  background-color: #ff000082;
  box-shadow: inset 0px 0px 20px 13px #fb000c;
  /* cursor: pointer; */
}
.cellDiv1HalfAbsent {
  border: solid thin #4ccaef;
  background-color: GreenYellow;
  box-shadow: inset 38px 0px 0px 0px #fb000c;
  cursor: pointer;
}
.cellDiv1HalfAbsentWithLeave {
  border: solid thin #4ccaef;
  background-color: GreenYellow;
  box-shadow: inset 30px 0px 0px 0px #f7fb00;
  cursor: pointer;
}
.cellDiv2HalfAbsent {
  border: solid thin #4ccaef;
  background-color: GreenYellow;
  box-shadow: inset -30px 0px 0px 0px #fb000c;
  cursor: pointer;
}
.cellDiv2HalfAbsentWithLeave {
  border: solid thin #4ccaef;
  background-color: GreenYellow;
  box-shadow: inset -30px 0px 0px 0px #f7fb00;
  cursor: pointer;
}
.cellDiv1HalfLeaveWithFullAbsent {
  border: solid thin #4ccaef;
  background-color: #fb000c;
  box-shadow: inset 30px 0px 0px 0px #f7fb00;
  cursor: pointer;
}
.cellDiv2HalfLeaveWithFullAbsent {
  border: solid thin #4ccaef;
  background-color: #fb000c;
  box-shadow: inset -30px 0px 0px 0px #f7fb00;
  cursor: pointer;
}
.cellDivLeaveWithFullAbsent {
  background: Orange !important;
  border: solid thin #4ccaef;
  box-shadow: inset 0px 0px 20px 7px #f7fb00;
}
.cellDivHoliday {
  border: solid thin #4ccaef;
  background-color: #f700fb;
  box-shadow: inset 0px 0px 11px 0px #a4a0a5;
}
.cellDivHoliday:hover {
  border: solid thin #4ccaef;
  background-color: #f700fb;
  box-shadow: 0px 0px 20px 8px #f700fb;
  content: "HOLIDAY";
}
.cellDivHolidayWithCompAtt {
  border: solid thin #4ccaef;
  background-color: #f700fb;
  box-shadow: inset 0px 0px 11px 0px #a4a0a5;
}
.cellDivFullOff {
  /* border: solid thin darkgray; */
  /* background-color: Orange; */
  background-color: #a9a9a970;
  border: solid thin #a9a9a970;
  /*box-shadow: inset 0px 0px 20px 20px #e5dfe6fa;*/
}
.cellDivFullOffWithCompAtt {
  border: solid GreenYellow;
  background-color: Orange;
  /*box-shadow: inset 0px 0px 20px 20px #e5dfe6fa;*/
}
.cellDivHalfOff {
  border: solid thin darkgray;
  background: linear-gradient(180deg, GreenYellow 50%, Orange 50%);
  cursor: pointer;
}
.calHead {
  font-weight: 700;
}
.PrvNext a.glyphicons:before {
  font-size: 20px;
  cursor: pointer;
}
.WeekSelect a.glyphicons:before {
  font-size: 16px;
  cursor: pointer;
}
.SelectedWeek {
  background-color: #0000ff30;
}
.dayData {
  font-family: "Courier New", Courier, monospace;
  font-weight: 800;
  display: block;
  margin-top: 2px;
  text-align: center;
  border: solid 1px #a9a9a93b;
  border-radius: 8px;
}
.offdayData {
  font-family: "Courier New", Courier, monospace;
  display: block;
  text-align: center;
  position: relative;
  top: 20px;
  font-weight: bold;
  font-size: 11px;
  /* transform: rotate(-38deg); */
}
.gridcellInsideDiv {
  height: 60px;
  border-radius: 4px;
  width: 100%;
}
.gridSpan {
  display: block;
  text-align: center;
}
.cellCheckbox {
  text-align: center;
}
/*Customize the label */
.chkContainer {
  display: block;
  position: relative;

  font-size: 19px;
  user-select: none;
}
.cellDiv > .chkContainer {
  cursor: pointer;
}
/*Hide the browser default checkbox*/
.chkContainer input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}
/*create a custom checkbox*/
.checkmark {
  position: absolute;
  top: 1px;
  left: 0;
  color: Black;
  /* height: 22px; */
  width: 22px;
  text-align: center;
  border-radius: 5px;
  font-size: 15px;
}
/*On mouse-over , add a grey background*/
.chkContainer:hover input ~ .checkmark {
  background-color: #ccc;
}

/*When the checkbox is checked ,add a blue background */
.chkContainer input:checked ~ .checkmark {
  background-color: #2196f3;
}

/*Create the checkmark/indicator (hidden when not checked)*/
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
/*show the checkmark when checked*/
.chkContainer input:checked ~ .checkmark:after {
  display: block;
}
/*style the checkmark indicator*/
.chkContainer .checkmark:after {
  left: 4px;
  top: 9px;
  width: 5px;
  height: 10px;
  border: solid cornsilk;
  border-width: 0px 4px 4px 0px;
  transform: rotate(45deg);
}
.HalfoffdayData {
  font-family: "Courier New", Courier, monospace;
  font-family: "Courier New", Courier, monospace;
  display: block;
  text-align: center;
  transform: rotate(-38deg);
}
.dayClass {
  border-radius: 5px;
  display: inline-block;
  font-size: medium;
  padding-top: 3px;
  /* background-color: #cacaca63;*/
  width: 24px;
  text-align: center;
  z-index: 1000;
  position: relative;
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/SlotCalender.vue